class Logger {
  constructor() {
    this.prefix = '[GamePortal]';
  }

  formatMessage(message, type) {
    const timestamp = new Date().toISOString();
    return `${this.prefix} [${timestamp}] [${type.toUpperCase()}] ${message}`;
  }

  info(message, ...args) {
    const formattedMessage = this.formatMessage(message, 'INFO');
    if (args.length > 0) {
      console.log(formattedMessage, ...args);
    } else {
      console.log(formattedMessage);
    }
  }

  error(message, ...args) {
    const formattedMessage = this.formatMessage(message, 'ERROR');
    if (args.length > 0) {
      console.error(formattedMessage, ...args);
    } else {
      console.error(formattedMessage);
    }
  }

  warn(message, ...args) {
    const formattedMessage = this.formatMessage(message, 'WARN');
    if (args.length > 0) {
      console.warn(formattedMessage, ...args);
    } else {
      console.warn(formattedMessage);
    }
  }

  debug(message, ...args) {
    if (process.env.NODE_ENV === 'development') {
      const formattedMessage = this.formatMessage(message, 'DEBUG');
      if (args.length > 0) {
        console.debug(formattedMessage, ...args);
      } else {
        console.debug(formattedMessage);
      }
    }
  }
}

export default new Logger(); 